import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@material-ui/core/styles';
import ICode from '@meronex/icons/fi/FiHash';
import IUnit from '@meronex/icons/fi/FiLayers';
import ICheck from '@meronex/icons/fi/FiCheckCircle';
import { Icons } from '../../../common/Icons';

import SitesAvatar from '../../../common/SitesAvatar';

function ItemType(props) {
  const {
    data,
    onClick,
    store,
    permissions,
  } = props;

  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const itemType = data;
  if (!itemType) return null;

  const imgSrc = itemType.image ? itemType.image.thumbUrl : undefined;

  let added = false;
  if (store && Array.isArray(itemType.addedToStores)) {
    added = itemType.addedToStores.includes(store._id);
  }

  const mutedColor = isDark ? 'rgba(255,255,255,0.45)' : '#94a3b8';
  const textColor = isDark ? 'rgba(255,255,255,0.85)' : '#1e293b';

  return (
    <div
      onClick={() => onClick(itemType)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '10px 20px',
        cursor: 'pointer',
        borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9'}`,
        transition: 'background-color 0.15s ease',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.03)' : '#f8fafc'; }}
      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}>
      <div style={{ flexShrink: 0 }}>
        <SitesAvatar
          image={imgSrc}
          name={itemType.name}
          size={44}
          round={10}
        />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '14px',
          fontWeight: 500,
          color: added ? mutedColor : textColor,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}>
          {itemType.name}
          {itemType.archived && (
            <span style={{ fontSize: '11px', color: mutedColor, marginLeft: '6px' }}>(archived)</span>
          )}
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          fontSize: '12px',
          color: mutedColor,
          marginTop: '3px',
        }}>
          {itemType.code && (
            <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
              <ICode size={11} /> {itemType.code}
            </span>
          )}
          {itemType.category && itemType.category.name && (
            <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
              <Icons.Category style={{ fontSize: '11px' }} /> {itemType.category.name}
            </span>
          )}
          <span style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
            <IUnit size={11} /> {itemType.unit}
          </span>
          {permissions && permissions.viewPrices && itemType.price > 0 && (
            <span>
              {itemType.price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} AED/{itemType.unit}
            </span>
          )}
        </div>
      </div>
      {added && (
        <ICheck size={16} style={{ color: '#16a34a', flexShrink: 0 }} />
      )}
    </div>
  );
}

ItemType.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  enableAddToStore: PropTypes.bool,
};

ItemType.defaultProps = {
  enableAddToStore: true,
};

export default ItemType;
